export const FIELD_BOOLEAN = 'boolean';
export const FIELD_DATE = 'date';
export const FIELD_DECIMAL = 'decimal';
export const FIELD_ENUM = 'enum';
export const FIELD_NUMBER = 'number';
export const FIELD_TEXT = 'text';
export const FIELD_USER = 'user';
export const FIELD_EMPLOYEE = 'employee';
export const FIELD_PERIOD = 'period';
